import React from "react";
import { Dropdown } from "primereact/dropdown";
import {
  MAX_TREND_MONTHS,
  MIN_TREND_MONTHS,
} from "../../../../types/onboardingAnalytics";

interface MonthsSelectorProps {
  value: number;
  onChange: (months: number) => void;
  ariaLabel?: string;
}

// Only ranges the API accepts. Outside 1–24 it answers 400, so offering a wider
// choice would be offering a control that fails.
const OPTIONS = [3, 6, 12, 24]
  .filter((m) => m >= MIN_TREND_MONTHS && m <= MAX_TREND_MONTHS)
  .map((m) => ({ label: `Last ${m} months`, value: m }));

const MonthsSelector: React.FC<MonthsSelectorProps> = ({
  value,
  onChange,
  ariaLabel = "Month range",
}) => (
  <Dropdown
    value={value}
    options={OPTIONS}
    onChange={(e) => onChange(e.value)}
    className="w-auto"
    aria-label={ariaLabel}
  />
);

export default MonthsSelector;
